<template>
  <span>
    <a-upload :file-list="fileList"
              :accept="accept"
              :remove="handleRemove"
              :before-upload="beforeUpload">
      <a-button :size="btnSize"> <a-icon type="upload" /> {{btnName}} </a-button>
      <span class="descrition-text ml-3">{{ label }}</span>
    </a-upload>
    <div v-for="(file) in fileList"
         :key="file.id"
         class="file_list">
      <a>{{ file.name }}</a>
      <div class="delete">
        <a-popconfirm title="是否确认删除?"
                      @confirm="handleRemove(file)">
          <a-icon type="delete"
                  style="font-size: 16px;" />
        </a-popconfirm>
      </div>
    </div>
  </span>

</template>

<script>
export default {
  name: 'UploadFile',
  props: {
    btnName: {
      type: String,
      default: '上传附件'
    },
    accept: {
      type: String,
      default: ''
    },
    btnSize: {
      type: String,
      default: 'small'
    },
    max: {
      type: Number,
      required: false,
      default: 99
    },
    // 限制文件大小，以M为单位
    fileSize: {
      type: Number,
      default: 2
    },
    label: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      fileList: [],
      uploading: false,
    }
  },
  methods: {
    handleRemove (file) {
      const that = this
      this.$confirm({
        title: '是否确认删除' + file.name + "？",
        onOk () {
          const index = that.fileList.indexOf(file)
          const newFileList = that.fileList.slice()
          newFileList.splice(index, 1)
          that.fileList = newFileList
          that.$emit('change', newFileList)
        },
      })
    },
    beforeUpload (file) {
      return new Promise(async (resolve, reject) => {
        if (this.fileList.length + 1 > this.max) {
          this.$warning({ title: '最多上传 ' + this.max + ' 个文件' })
          return reject(false)
        }
        if (!this.accept.includes(file.type.split("/")[1])) {
          this.$message.error('请按照格式要求进行上传')
          return reject(false)
        }
        const size = file.size
        if ((size / 1024 / 1024) > this.fileSize) {
          this.$message.error(`上传文件不能大于${this.fileSize}M`)
          return reject(false)
        }
        this.fileList = [...this.fileList, file]
        this.$emit('change', this.fileList)
        return reject(false)
      })
    },
  },
}
</script>

<style lang="less" scoped>
/deep/ .ant-upload-list {
  display: none;
}
.file_list {
  background: #f9f9f9;
  padding: 6px 12px;
  margin-bottom: 8px;
  display: block;
  position: relative;
  line-height: 20px;
  height: 32px;
}

.file_list:nth-last-child(1) {
  margin-bottom: 0;
}

.file_list span {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
  vertical-align: top;
  position: absolute;
  max-width: 100%;
  padding-right: 140px;
  box-sizing: border-box;
}
.file_list .delete {
  position: absolute;
  right: 12px;
  top: 6px;
}

.file_list .delete:hover i {
  color: #ff0000;
  cursor: pointer;
}
.descrition-text {
  color: #bfbfc4;
}
</style>
